import UrlHelpers from "./url";
import {FieldHandler} from "./fieldHandler";
import {Notification} from "./notification";
import {i18n} from "./i18n";
import {dtoProvider, dtoProviderDetails} from "./providerList";
import {setContextActions} from "./contextActions";
import {provider_edit_delete, provider_edit_saved} from "./dapiEventUris";
import {deleteIcon, saveIcon} from "./icons";
import {isEmailValid, isUrlValid} from "./validation";
import {ErrorHandler} from "./errorHandler";
import {MediamanagerFileInputHandler} from "./mediamanagerFileInput";

export class ProviderEdit {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();
    private _isSysAdmin:boolean = UrlHelpers.getMetaData('sysAdmin')==="1";
    private _viewState:dtoProvider;

    constructor() {
        (<HTMLSelectElement>document.getElementById('providerCaptions_languageSelector')).addEventListener('change', this._languageSelectorChanged);
        (<HTMLButtonElement>document.getElementById('modalDeleteProvider_btnDelete')).addEventListener('click',this._deleteProvider);
        (<HTMLButtonElement>document.getElementById('modalDeleteProvider_btnCancel')).addEventListener('click', (e) => {
            const modal = this._dux.query('#modalDeleteProvider');
            if (modal) {
                modal.hide();
            } else {
                console.debug("modal with id 'modalDeleteProvider' not found!");
            }
        })
        this._addCaptionActionEvents();
        this._addCtxActions();
        this._setViewState();
        this._addMediamanager();
        if(this._dapi.isMainResource()){
            this._dapi.publishLocation(location.href);
        }
    }

    private _addMediamanager = () => {
        const logoId = 'providerLogo';
        const logoInput = <HTMLInputElement>document.getElementById(logoId);
        new MediamanagerFileInputHandler(<HTMLInputElement>document.getElementById('providerLogoFileChooser'), (source) => {
            logoInput.setAttribute("value", source);
            FieldHandler.setFieldValue(logoId, source);
            const evt = document.createEvent('HTMLEvents');
            evt.initEvent('input', false, true);
            logoInput.dispatchEvent(evt);
        });
        logoInput.addEventListener('input', () => {
            (<HTMLImageElement>document.getElementById('providerLogoThumbnail')).setAttribute('src', logoInput.value);
        });
    };

    private _setViewState = () => {
        this._viewState = this._getValues(false);
    };

    private _isViewStateChanged = ():boolean => {
        let currentState:dtoProvider = this._getValues(false);
        if(currentState.provider.city != this._viewState.provider.city) {
            return true;
        } else if(currentState.provider.country != this._viewState.provider.country) {
            return true;
        } else if(currentState.provider.email != this._viewState.provider.email) {
            return true;
        } else if(currentState.provider.homepage != this._viewState.provider.homepage) {
            return true;
        } else if(currentState.provider.language != this._viewState.provider.language) {
            return true;
        } else if(currentState.provider.logo != this._viewState.provider.logo) {
            return true;
        } else if(currentState.provider.name != this._viewState.provider.name) {
            return true;
        } else if(currentState.provider.street != this._viewState.provider.street) {
            return true;
        } else if(currentState.provider.supportMail != this._viewState.provider.supportMail) {
            return true;
        } else if(currentState.provider.supportPhone != this._viewState.provider.supportPhone) {
            return true;
        } else if(currentState.provider.zip != this._viewState.provider.zip) {
            return true;
        } else if(currentState.provider.impressum != this._viewState.provider.impressum) {
            return true;
        } else if(currentState.provider.description != this._viewState.provider.description){
            return true;
        }
        return false;
    };

    private _languageSelectorChanged = (e):void => {
        let selectedOptions = e.currentTarget.selectedOptions[0];
        let targetUrl = selectedOptions.dataset['url'];
        if(this._isViewStateChanged()){
            (<HTMLAnchorElement>document.getElementById('modalDtoChanged_btnSave')).addEventListener('click', this._btnSaveChanges_Click);
            (<HTMLAnchorElement>document.getElementById('modalDtoChanged_btnReject')).addEventListener('click', this._btnRejectChanges_Click);
            let dialog = this._dux.query('#modalDtoChanged');
            dialog[0].dataset['url'] = targetUrl;
            dialog.modal('toggle');
            return
        }
        location.href = targetUrl;
    };

    private _btnRejectChanges_Click = ():void => {
        let modal = document.getElementById('modalDtoChanged');
        let targetUrl = modal.dataset['url'];
        window.location.href = targetUrl;
    };

    private _btnSaveChanges_Click = (): void => {
        let modal = document.getElementById('modalDtoChanged');
        let targetUrl = modal.dataset['url'];
        this._save_click(targetUrl.toString());
    };

    private _addCtxActions = ():void => {
        let ctx = new Array<IContextAction>();
        ctx.push({
            title:this._i18n.getTranslation('btn_save_title'),
            icon:saveIcon,
            callback:() => {
                this._save_click();
            }
        });
        if(this._isSysAdmin){
            ctx.push({
                title: this._i18n.getTranslation('provider_edit_ctx_action_delete_label'), //"Provider löschen",
                icon:deleteIcon,
                callback:() => {
                    let modal = this._dux.query('#modalDeleteProvider');
                    if(modal){
                        modal.toggle('show');
                    } else {
                        console.warn('modal delete provider not found!');
                    }
                }
            });
        }
        //this._dapi.setContextActions(ctx);
        setContextActions(this._dapi, this._i18n, ctx);
    };

    private _addCaptionActionEvents = ():void => {
        (<HTMLButtonElement>document.getElementById('modalAddTranslation_btnAdd')).addEventListener('click', this._addTranslationClick);
        (<HTMLButtonElement>document.getElementById('modalRemoveTranslation_btnRemove')).addEventListener('click', this._removeTranslationClick);
    };

    private _addTranslationClick = (e): void => {
        let translationLanguage = (<HTMLSelectElement>document.getElementById('modalAddTranslation_translationLanguageSelector')).value;
        let url = UrlHelpers.getLinkRelHref('details') +"?translation="+translationLanguage;

        let copyFrom = (<HTMLSelectElement>document.getElementById('modalAddTranslation_copyFrom')).value;
        if (copyFrom && copyFrom != "0"){
            url = url + "&copy=" + copyFrom;
        }

        let xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader('accept','application/json');
        xhr.onload = ()=> {
            if(xhr.status === 201) {
                // this._refreshLanguageSelector(translationLanguage);
                let targetUrl = xhr.getResponseHeader("location");
                this._dux.query('#modalAddTranslation').modal('hide');
                if(!targetUrl.isNullOrEmpty()) {
                    location.href = targetUrl;
                }
            } else {
                let msg = this._i18n.getTranslation('app_edit_modal_add_translation_failed_msg');
                let help = (<HTMLSpanElement>document.getElementById('modalAddTranslation_translationLanguageSelector_Help'));
                if(help){
                    help.innerHTML='<i class="dv dv-warning"></i>&nbsp;'+msg;
                } else {
                    console.warn("Cannot find help span within add translation modal.");
                }
                console.error("Return status " + xhr.status + ": " + xhr.responseText);
            }
        };
        xhr.send();
    };

    private _removeTranslationClick = (e): void => {
        let currentLanguage = FieldHandler.getFieldValue('providerCaptions_languageSelector');
        // alert('Delete current selected language: '+currentLanguage);
        let url = UrlHelpers.getLinkRelHref('self') + "?translation="+currentLanguage;
        let xhr = new XMLHttpRequest();
        xhr.open('DELETE', url);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.onload = () => {
            this._dux.query('#modalRemoveTranslation').modal('hide');
            if(xhr.status === 204) {
                // this._refreshLanguageSelector("");
                let targetUrl = UrlHelpers.getLinkRelHref('details');
                location.href = targetUrl;
            } else {
                console.error("Return status " + xhr.status + ": " + xhr.responseText);
                Notification.showErrorNotification(this._i18n.getTranslation('provider_edit_notification_remove_failed_title'), this._i18n.getTranslation('provider_edit_notification_remove_failed_message'));
            }
        };
        xhr.send();
    };

    private _save_click = (targetUrl?: string):void => {
        let data = this._getValues();
        if(data != null){
            let url = UrlHelpers.getLinkRelHref('self');
            let xhr = new XMLHttpRequest();
            xhr.open('PUT', url);
            xhr.setRequestHeader('accept', 'application/json');
            xhr.onload = () => {
                if(xhr.status === 200){
                    this._viewState = data;
                    this._dapi.dispatchResourceEvent({
                        name:'changed',
                        uri: provider_edit_saved
                    });
                    if(targetUrl.isNullOrEmpty()) {
                        this._dapi.closeResourceIfMainResource();
                    } else {
                        location.href = targetUrl;
                    }
                } else if (xhr.status === 409) {
                    console.error(xhr.responseText);
                    Notification.showErrorNotification(this._i18n.getTranslation('provider_edit_notification_save_failed_title'), this._i18n.getTranslation('provider_list_modal_create_provider_error_prefix_already_exist_message'));
                } else {
                    if (xhr.status === 400) {
                        let errorDto = ErrorHandler.parseError(xhr.responseText);
                        if(errorDto.description.startsWith('Provider prefix is invalid')) {
                            FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_invalid_chars_message'));
                        } else if(errorDto.description.startsWith('Provider prefix is blacklisted')) {
                            FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_error_prefix_not_allowed_message'));
                        } else if(errorDto.description.startsWith('Provider prefix must contain at least 2 characters')) {
                            FieldHandler.setFieldError('providerPrefix', this._i18n.getTranslation('providerList_create_provider_info_prefix_max_length_reference_message'));
                        }
                    }
                    console.error(xhr.responseText);
                    Notification.showErrorNotification(this._i18n.getTranslation('provider_edit_notification_save_failed_title'),this._i18n.getTranslation('provider_edit_notification_save_failed_message'));
                }
            };
            xhr.send(JSON.stringify(data));
        } else {
            console.warn('Required fields are empty!');
        }
    };

    private _getValues = (useEmptyCheck = true):dtoProvider => {
        let errorMsg:{[key:string]:string} = {};
        let errorExist:boolean = false;
        let providerId:string = FieldHandler.getFieldValue('providerId');
        if (providerId.isNullOrEmpty() && useEmptyCheck){
            console.error('provider id cannot be found. Please reload this page!');
            return null;
        }
        let prefix:string = FieldHandler.getFieldValue('providerPrefix');
        let language:string = FieldHandler.getFieldValue('language');
        FieldHandler.clearFieldError('providerName_');
        let field_name:string = FieldHandler.getFieldValue('providerName');
        if (field_name.isNullOrEmpty() && useEmptyCheck){
            console.warn('field "providerName" required but is empty');
            let msg = this._i18n.getTranslation('provider_prop_name_error_is_empty');
            let label = (<HTMLLabelElement>document.getElementById('providerName_label')).innerText;
            FieldHandler.setFieldError('providerName_', msg);
            errorMsg[label] = msg;
            errorExist = true;
        }
        let field_description:string = FieldHandler.getFieldValue('providerDescription');
        field_description = field_description.replace(/\n/g, '<br>\n');

        let field_street:string = FieldHandler.getFieldValue('providerStreet');
        let field_zip:string = FieldHandler.getFieldValue('providerZip');
        let field_city:string = FieldHandler.getFieldValue('providerCity');
        let field_country:string = FieldHandler.getFieldValue('providerCountry');
        let field_homepage:string = FieldHandler.getFieldValue('providerHomepage');
        if(!isUrlValid(field_homepage, false)) {
            console.warn('field "providerHomepage" has invalid url');
            let msg = this._i18n.getTranslation('provider_prop_homepage_error_invalid');
            FieldHandler.setFieldError('providerHomepage_', msg);
            let label = (<HTMLLabelElement>document.getElementById('providerHomepage_label')).innerText;
            errorMsg[label] = msg;
            errorExist = true;
        }
        let field_impressum:string = FieldHandler.getFieldValue('providerImpressum');
        if(!isUrlValid(field_homepage, false)) {
            console.warn('field "providerImpressum" has invalid url');
            let msg = this._i18n.getTranslation('provider_prop_homepage_error_invalid');
            FieldHandler.setFieldError('providerImpressum_', msg);
            let label = (<HTMLLabelElement>document.getElementById('providerImpressum_label')).innerText;
            errorMsg[label] = msg;
            errorExist = true;
        }
        let field_mail:string = FieldHandler.getFieldValue('providerMail');
        if(!isEmailValid(field_mail, false)) {
            console.warn('field "providerMail" has an invalid mail address');
            let msg = this._i18n.getTranslation('provider_prop_email_error_invalid');
            FieldHandler.setFieldError('providerMail_', msg);
            let label = (<HTMLLabelElement>document.getElementById('providerMail_label')).innerText;
            errorMsg[label] = msg;
            errorExist = true;
        }
        let field_support_mail:string = FieldHandler.getFieldValue('providerSupportMail');
        if(!isEmailValid(field_support_mail, false)) {
            console.warn('field "providerSupportMail" has an invalid mail address');
            let msg = this._i18n.getTranslation('provider_prop_supportmail_error_invalid');
            FieldHandler.setFieldError('providerSupportMail_', msg);
            let label = (<HTMLLabelElement>document.getElementById('providerSupportMail_label')).innerText;
            errorMsg[label] = msg;
            errorExist = true;
        }
        let field_support_phone:string = FieldHandler.getFieldValue('providerSupportPhone');
        let field_logo:string = FieldHandler.getFieldValue('providerLogo');
        if (errorExist) {
            let title = this._i18n.getTranslation('provider_edit_error_not_save_title');
            let alert = this._i18n.getTranslation('provider_edit_error_not_save_message');
            let body = '<ul>';
            for (let key in errorMsg){
                let msg = errorMsg[key];
                body = `${body}<li><strong>${key}:</strong>&nbsp;${msg}</li>`;
                errorExist = true;
            }
            body = `${body}</ul>`;
            ErrorHandler.showErrorDialogByOwn(title, alert, body, 'danger', this._dux);
            return null
        }
        let provider: dtoProviderDetails = {
            name: field_name,
            street: field_street,
            zip: field_zip,
            city: field_city,
            country: field_country,
            homepage: field_homepage,
            email: field_mail,
            supportMail: field_support_mail,
            supportPhone: field_support_phone,
            logo: field_logo,
            language: language,
            prefix: prefix,
            impressum: field_impressum,
            description:field_description
        };
        let retVal: dtoProvider = {
            members: null,
            id: providerId,
            provider: provider
        };
        return retVal;
    };

    private _deleteProvider = (): void => {
        let url = UrlHelpers.getLinkRelHref('self');
        if (url.isNullOrEmpty()){
            console.error('delete provider failed: provider self url is empty!');
            return
        }
        let xhr = new XMLHttpRequest();
        xhr.open('DELETE', url);
        xhr.setRequestHeader('accept','application/json');
        xhr.onload = () => {
            if(xhr.status === 204) {
                this._dapi.dispatchResourceEvent({
                    name: "deleted",
                    uri: provider_edit_delete,
                });
                if(this._dapi.isMainResource()) {
                    this._dapi.closeResourceIfMainResource();
                } else {
                    let parentUrl = UrlHelpers.getLinkRelHref('parent');
                    if(!parentUrl.isNullOrEmpty()) {
                        location.href = parentUrl;
                    } else {
                        console.warn("parent url not found!");
                    }
                }
            } else if (xhr.status >= 400) {
                console.error(xhr);
                let modal = this._dux.query('#modalDeleteProvider');
                if(modal){
                    modal.hide();
                }
                Notification.showErrorNotification(this._i18n.getTranslation('provider_edit_notification_delete_failed_title'),this._i18n.getTranslation('provider_edit_notification_delete_failed_message'));
            }
        };
        try{
            xhr.send();
        } catch(exp){
            console.error('delete provider failed: ', exp);
        }
    };
}